var _circle, _circle2, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourGlassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5098,
    cy: 51.51,
    r: 50.5,
    fill: "white",
    stroke: "#EC9832",
    strokeWidth: 2.02,
    strokeLinecap: "round",
    strokeDasharray: "4.04 4.04"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2402_26056",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5098,
    cy: 51.51,
    r: 50.5,
    stroke: "#EC9832",
    strokeWidth: 2.02,
    strokeLinecap: "round",
    strokeDasharray: "4.04 4.04"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2402_26056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8324 -3.11306C59.9399 -3.90144 59.3881 -4.62966 58.5972 -4.7167C57.8063 -4.80374 57.1093 -4.21294 57.0428 -3.42004L52.5207 50.5L59.8324 -3.11306Z",
    fill: "#DBDBD7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2689 34.4361C39.4849 31.8101 43.6603 31.8101 52.0089 31.8101C60.3576 31.8101 64.5329 31.8101 65.749 34.4361C65.854 34.6596 65.9415 34.8926 66.0116 35.135C66.8398 37.9367 63.8865 41.1849 57.9841 47.6792L54.0289 52.0101L57.9841 56.3389C63.8865 62.8352 66.8378 66.0834 66.0116 68.8831C65.9416 69.1236 65.8538 69.3586 65.749 69.5861C64.5329 72.2101 60.3576 72.2101 52.0089 72.2101C43.6603 72.2101 39.4849 72.2101 38.2689 69.5841C38.1642 69.3579 38.0765 69.1243 38.0063 68.8851C37.1781 66.0834 40.1313 62.8352 46.0338 56.3409L49.9889 52.0101L46.0338 47.6812C40.1313 41.1829 37.1821 37.9367 38.0063 35.137C38.0763 34.8946 38.1639 34.6623 38.2689 34.4361Z",
    fill: "url(#paint0_linear_2402_26056)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2402_26056",
    x1: 53.6727,
    y1: 27.0587,
    x2: 53.6727,
    y2: 72.2096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC9832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFA87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8EAB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourGlassIcon);
export default __webpack_public_path__ + "static/media/hour-glass-icon.be451b71aaf079da7423286af91e7dc0.svg";
export { ForwardRef as ReactComponent };